module.exports = __webpack_public_path__ + "img/collaborate_38.57ce1215.jpg";